module.exports = function(bh) {
    bh.match('image', function(ctx, json) {
        const width = ctx.attr('width');
        const height = ctx.attr('height');
        ctx.attr('width', null, true);
        ctx.attr('height', null, true);
        ctx.attr('style', `${width ? `--width: ${width}; ` : ''}${height ? `--height: ${height};` : ''}`);
        ctx.content({block: 'img', mods: {lazy: true}, src: json.src || `http://placehold.it/${ctx.mod('size') || '260x260'}`});
        ctx.content([
            {elem: 'inner', content: [
                ctx.content(),
            ]},
        ], true);
    });
};
